<template>
  <div>
    <with-loader :id="'variables-table'"
      :loading="isLoading"
      class="rounded-lg outline-soft border-soft"
      use-as-overlay
    >
        <table class="w-full rounded-l border-collapse">
          <thead class="bg-gray text-white rounded-lg">
            <tr class="flex w-full py-2">
              <th class="w-3/12 flex justify-between cursor-pointer pl-7" @click="handleSorter()">
                <span class="text-base font-normal">Variable</span>
                <sortable-table-arrows :column-id="1" :sort="sortOrder"/>
              </th>
              <th class="w-5/12 text-base font-normal">Value</th>
              <th class="w-3/12 text-base font-normal">Scope</th>
              <th class="w-1/12 text-base font-normal"></th>
            </tr>
          </thead>
          <tbody v-bar>
            <div class="divide-x-0 divide-y divide-solid divide-soft max-h-75vh">
              <variables-table-row v-for="(variable, i) in variableTableData"
                :key="i"
                :variable="variable"
                :store-index="getStoreIndex(variable.id)"
                @view-variable-usages="handleViewVariableUsages"
              />
            </div>
          </tbody>
        </table>
    </with-loader>

    <drawer-card v-if="showDrawer" v-model="showDrawer" drawer-width="40%" fullscreen-overlay>
      <template #drawer-content>
        <variables-usages :variable-id="viewedVariableIdUsages"
                          @show-item="showDrawer = false"
        />
      </template>
    </drawer-card>
  </div>
</template>

<script>
import sanitizeString from 'replace-special-characters'
import variablesModule from '@/store/modules/variables.module'
import VariablesTableRow from '@/components/settings/variables/VariablesTableRow.vue'
import VariablesUsages from '@/components/settings/variables/VariablesUsages.vue'
import DrawerCard from '@/components/base-components/DrawerCard.vue'
import WithLoader from '@/components/common/WithLoader'
import SortableTableArrows from '@/components/common/SortableTableArrows'
import clone from 'ramda/src/clone'

export default {
  name: 'VariablesTable',

  components: { DrawerCard, VariablesUsages, VariablesTableRow, SortableTableArrows, WithLoader },

  props: {
    searchQuery: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      sortOrder: 'asc',
      showDrawer: false,
      viewedVariableIdUsages: null,
      variableTableData: []
    }
  },

  watch: {
    variablesList: {
      handler() {
        this.variableTableData = this.variablesList
      },
      immediate: false
    },

    searchQuery: {
      handler() {
        this.variableTableData = this.sortTableData(this.filterTableData(this.variablesList))
      },
      immediate: false
    }
  },

  computed: {
    isLoading: variablesModule.variablesLoading,

    variablesList() {
      return variablesModule.variables.get()
    }
  },

  methods: {
    handleSorter() {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      this.variableTableData = this.sortTableData(this.variablesList)
    },

    sortTableData(tableData) {
      return clone(tableData).sort((a, b) => {
        return this.sortOrder === 'asc' ?
          (a.name || '').localeCompare(b.name || '') :
          (b.name || '').localeCompare(a.name || '')
      })
    },

    filterTableData(tableData) {
      if (!this.searchQuery) return tableData

      const term = sanitizeString(this.searchQuery.toLowerCase().trim())
      return tableData.filter(variable => {
        const name = sanitizeString((variable.name + variable.value).toLowerCase())
        return name.includes(term)
      })
    },

    getStoreIndex(variableId) {
      return this.variablesList.findIndex(v => v.id === variableId)
    },

    handleViewVariableUsages(variableId) {
      this.showDrawer = !this.showDrawer
      this.viewedVariableIdUsages = variableId
    }
  },

  mounted() {
    this.variableTableData = this.sortTableData(this.variablesList)
  }
}
</script>
